module.exports = __webpack_public_path__ + "static/media/icc-logo-white.97a444d5.png";